import React from "react";

const Hero: React.FC = () => {
  return (
    <section
      className="relative flex items-center justify-center min-h-[480px] md:min-h-[720px]"
      style={{
        backgroundImage: "url(/images/hero-bg.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center 40%",
      }}
    >
      <div className="absolute inset-0 bg-black opacity-40"></div>
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="mb-8 text-white">
          <h1 className="text-2xl md:text-4xl font-bold mb-4">
            CYCLE COLLECTIVE SASKATOON
          </h1>
          <p className="text-base md:text-lg mb-4">
            2710 Lorne Avenue. Ste 20-30
          </p>
          <a
            href="/services"
            style={{
              backgroundColor: "var(--color-altBrand)",
              color: "var(--color-text)",
            }}
            className="px-4 py-2 md:px-6 md:py-3 text-sm md:text-base rounded hover:opacity-80"
          >
            BOOK A CLASS
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
